(function (app) {
    app.config([
        "$mdThemingProvider", function($mdThemingProvider) {
            $mdThemingProvider.disableTheming();
        }
    ]);
})(window.app);

//(function (app) {

//    app.config([

//        "$mdThemingProvider", function ($mdThemingProvider) {

//            var advisorPrimaryMap = $mdThemingProvider.extendPalette("blue", {
//                '50': "#199de3",
//                '100': "#199de3",
//                '200': "#199de3",
//                '300': "#224972",
//                '400': "#3169a5",

//                '500': '#224972',
//                'A100': '#cc3d3d',
//                'A200': '#224972',
//                'A400': '#224972',
//                'A700': '#224972',
//                'contrastDefaultColor': 'light'
//            });

//            $mdThemingProvider
//                .definePalette("advisorPrimary",
//                advisorPrimaryMap);



//            $mdThemingProvider.theme("default")
//                .primaryPalette("advisorPrimary", {
//                    'default': "400", 
//                    'hue-1': "100",
//                    'hue-2': "200",
//                    'hue-3': "300" 
//                })

//                .accentPalette("advisorPrimary")
//                .warnPalette("advisorPrimary", {
//                    'default': "A100"
//                });
//        }
//    ]);

//})(window.app); // jshint ignore:line

    //(function (app) {

    //    app.config([

    //        "$mdThemingProvider", function ($mdThemingProvider) {

    //            var customPrimary = {
    //                '50': '#9da7b7',
    //                '100': '#8e9aac',
    //                '200': '#808da1',
    //                '300': '#718096',
    //                '400': '#657389',
    //                '500': '#5a677a',
    //                '600': '#4f5b6b',
    //                '700': '#444e5d',
    //                '800': '#3a424e',
    //                '900': '#2f353f',
    //                'A100': '#acb4c1',
    //                'A200': '#bac2cc',
    //                'A400': '#c9cfd7',
    //                'A700': '#242931'
    //            };
    //            $mdThemingProvider
    //                .definePalette('customPrimary',
    //                customPrimary);

    //            var customAccent = {
    //                '50': '#191d22',
    //                '100': '#242931',
    //                '200': '#2f353f',
    //                '300': '#3a424e',
    //                '400': '#444e5d',
    //                '500': '#4f5b6b',
    //                '600': '#657389',
    //                '700': '#718096',
    //                '800': '#808da1',
    //                '900': '#8e9aac',
    //                'A100': '#657389',
    //                'A200': '#5a677a',
    //                'A400': '#4f5b6b',
    //                'A700': '#9da7b7'
    //            };
    //            $mdThemingProvider
    //                .definePalette('customAccent',
    //                customAccent);

    //            var customWarn = {
    //                '50': '#9da7b7',
    //                '100': '#8e9aac',
    //                '200': '#808da1',
    //                '300': '#718096',
    //                '400': '#657389',
    //                '500': '#5a677a',
    //                '600': '#4f5b6b',
    //                '700': '#444e5d',
    //                '800': '#3a424e',
    //                '900': '#2f353f',
    //                'A100': '#acb4c1',
    //                'A200': '#bac2cc',
    //                'A400': '#c9cfd7',
    //                'A700': '#242931'
    //            };
    //            $mdThemingProvider
    //                .definePalette('customWarn',
    //                customWarn);

    //            var customBackground = {
    //                '50': '#f8f8f8',
    //                '100': '#8e9aac',
    //                '200': '#808da1',
    //                '300': '#718096',
    //                '400': '#657389',
    //                '500': '#5a677a',
    //                '600': '#4f5b6b',
    //                '700': '#444e5d',
    //                '800': '#3a424e',
    //                '900': '#2f353f',
    //                'A100': '#f7f9fb',
    //                'A200': '#bac2cc',
    //                'A400': '#c9cfd7',
    //                'A700': '#242931'
    //            };
    //            $mdThemingProvider
    //                .definePalette('customBackground',
    //                customBackground);

    //            $mdThemingProvider.theme('default')
    //                .primaryPalette('customPrimary')
    //                .accentPalette('customAccent')
    //                .warnPalette('customWarn')
    //                .backgroundPalette('customBackground');
    //        }
    //    ]);

    //})(window.app); // jshint ignore:line

